/**
 * @license
 * Copyright (c) Peculiar Ventures, LLC.
 *
 * This source code is licensed under the BSD 3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {
  FunctionalComponent,
  h,
  VNode,
} from '@stencil/core';
import { Typography } from '@peculiar/certificates-viewer';
import { FortifyLogo } from './fortify_logo';

export interface FortifyStatusProps {
  title: string;
  description?: string;
  illustration?: VNode;
}

export const FortifyStatus: FunctionalComponent<FortifyStatusProps> = (props, children) => {
  const {
    title,
    description,
    illustration,
  } = props;

  return (
    <div class="container_status">
      <div class="container_status_content">
        <FortifyLogo
          class="container_status_logo"
        />
        <Typography
          variant="h4"
          color="black"
        >
          {title}
        </Typography>
        {description && (
          <Typography
            variant="b3"
            color="gray-9"
            class="mt_4"
          >
            {description}
          </Typography>
        )}
      </div>
      {illustration && (
        <div class="container_status_illustration">
          {illustration}
        </div>
      )}
      <div class="container_status_actions mt_6">
        {children}
      </div>
    </div>
  );
};
